import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-brand-accent text-brand-accent-foreground hover:brightness-[0.94]",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        // Variantes semánticas con opacidad
        success: "bg-green-50 text-green-700 border-green-200",
        warning: "bg-amber-50 text-amber-700 border-amber-200",
        error: "bg-red-50 text-red-700 border-red-200",
        neutral: "bg-slate-50 text-slate-600 border-slate-200",
        primary: "bg-primary/10 text-primary border-primary/20",
        // Variantes de módulos WorkOps
        integrations: "border-transparent bg-module-integrations text-white hover:bg-module-integrations/90",
        organization: "border-transparent bg-module-organization text-white hover:bg-module-organization/90",
        access: "border-transparent bg-module-access text-white hover:bg-module-access/90",
        generation: "border-transparent bg-module-generation text-white hover:bg-module-generation/90",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }














